module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0056.jpg?v=1c75172a";